import { useQuery } from '@apollo/client'
import { WarningAmberOutlined as WarningOutlined } from '@mui/icons-material'
import { Link } from '@resiliatech/birdsong'
import { NEEDS_USER_SURVEY_UPDATE } from 'Apollo/Queries/NeedsUserSurveyUpdate' // Import the query
import {
  BannerContainer,
  BannerHeader,
  BannerHeaderContainer,
  BannerText,
  UpdatePrioritiesLink,
} from './UserSurveyBanner.styles'

export const UserSurveyBanner = () => {
  const { data, loading, error } = useQuery(NEEDS_USER_SURVEY_UPDATE)

  if (loading) return null
  if (error || !data?.needsUserSurveyUpdate) return null

  return (
    <BannerContainer>
      <BannerHeaderContainer>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <WarningOutlined />
          <BannerHeader>Time to update!</BannerHeader>
        </div>

        <UpdatePrioritiesLink>
          <Link
            href='/check-in'
            underline='hover'
            style={{
              color: 'inherit',
            }}
          >
            Update Priorities
          </Link>
        </UpdatePrioritiesLink>
      </BannerHeaderContainer>
      <BannerText>
        This 8-minute survey will allow you to update and reflect on your
        current priorities, you will be also able to replace them.
        <br />
        The answers will be from now on visible and will be used to create
        reports.
      </BannerText>
    </BannerContainer>
  )
}
